import CustomButton from "../../../Components/Atoms/CustomButton";
import CustomSelect from "../../../Components/Atoms/CustomSelect";
import CustomInput from "../../../Components/Atoms/CustomInput";
import { useSelector } from "react-redux";
import { COMPONENTS } from "../../../Constant";

const VisitorOtpSubmission = ({ formik, parent_formik }) => {
  const { postOtpActionLoading } = useSelector(
    (state) => state.visitorLogReducer
  );

  return (
    <>
      <form autoComplete="off" onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex">
              <p className="mb-1">Send OTP Through</p>
              <p className="erroStar">*</p>
            </div>
            <CustomSelect
              type="text"
              name="type"
              placeholder="Select a type"
              onChange={(e) => {
                formik.handleChange(e);
                formik.setFieldValue("email_value", "");
                formik.setFieldValue("number_value", "");
                parent_formik.setFieldValue("basic_details.contact_no", "");
                parent_formik.setFieldValue("basic_details.email", "");
              }}
              onBlur={formik.handleBlur}
              value={formik.values.type}
              formik={formik}
              data={[
                { name: "EMAIL", value: "EMAIL" },
                { name: "SMS", value: "SMS" },
              ]}
            />
          </div>
          {formik.values.type === "EMAIL" ? (
            <div className="col-md-12">
              <div className="d-flex">
                <p className="mb-1">Email</p>
                <p className="erroStar">*</p>
              </div>
              <CustomInput
                type="text"
                component={COMPONENTS.EMAIL}
                name="email_value"
                placeholder="Enter email"
                onChange={(e) => {
                  formik.handleChange(e);
                  parent_formik.setFieldValue(
                    "basic_details.email",
                    e.target.value
                  );
                }}
                onBlur={formik.handleBlur}
                value={formik.values.email_value}
                formik={formik}
              />
            </div>
          ) : (
            <div className="col-md-12">
              <div className="d-flex">
                <p className="mb-1">Phone No</p>
                <p className="erroStar">*</p>
              </div>
              <CustomInput
                type="number"
                name="number_value"
                placeholder="Enter phone no"
                onChange={(e) => {
                  formik.handleChange(e);
                  parent_formik.setFieldValue(
                    "basic_details.contact_no",
                    e.target.value
                  );
                }}
                onBlur={formik.handleBlur}
                value={formik.values.number_value}
                formik={formik}
              />
            </div>
          )}
        </div>
        <div className="btnActnBar">
          <CustomButton
            label={postOtpActionLoading ? "Loading..." : "Send"}
            type={"submit"}
            action={"SEND"}
          />
        </div>
      </form>
    </>
  );
};
export default VisitorOtpSubmission;
